<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             
             >
</ngx-spinner>
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{ file.name }}</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <pdf-viewer [src]="file.filePath"
                [render-text]="true"
                [original-size]="false"
                [fit-to-page]="false"
                [autoresize]="true"
                (after-load-complete)="callBackFn($event)">
    </pdf-viewer>
</div>